import { render, staticRenderFns } from "./HeaterMonitorModuleWorkloadCard.vue?vue&type=template&id=9b5a7d34&scoped=true&"
import script from "./HeaterMonitorModuleWorkloadCard.vue?vue&type=script&lang=ts&"
export * from "./HeaterMonitorModuleWorkloadCard.vue?vue&type=script&lang=ts&"
import style0 from "./HeaterMonitorModuleWorkloadCard.vue?vue&type=style&index=0&id=9b5a7d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5a7d34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
